import dynamic from "next/dynamic";

export const BlueContentList = dynamic(() => import("./component"));
